import React, {useEffect, useState} from "react";
import {exibirMensagemErro, exibirMensagemSucesso, formatarDinheiroItl} from "../../util";
import {CirastServico} from "../../servicos";
import CardPadrao from "../../componentes/card/card-padrao";
import {TipoAtendimentoCirast} from "../../tipos/cirast/tipo-atendimento-cirast";
import {BotaoSalvar} from "../../componentes/botao/botao-mantine";
import {PaginaLogada} from "../../componentes";
import {ActionIcon, Grid, Modal, Stack, Table, TextInput, Tooltip} from "@mantine/core";
import {COL_RESP_3, COR, ICONE} from "../../config/constantes/constantes-mantine";
import {useDisclosure} from "@mantine/hooks";
import DinheiroInput from "../../componentes/form/dinheiro-input";
import {TipoAtendimentoCirastCmd} from "../../tipos/cmd/cirast/tipo-atendimento-cirast-cmd";

export default function CadastrarTipoCirast() {

  const [isCarregando, setIsCarregando] = useState(false)

  const [tipoCmd, setTipoCmd] = useState<TipoAtendimentoCirastCmd>(new TipoAtendimentoCirastCmd())
  const [tipos, setTipos] = useState<TipoAtendimentoCirast[]>()
  const [tipoEditar, setTipoEditar] = useState<TipoAtendimentoCirast>()
  const [modal, {open, close}] = useDisclosure(false);

  function enviar() {

    if (!tipoCmd.nome || !tipoCmd.valor) {
      exibirMensagemErro('Preencha o nome e o valor.')
      return
    }

    setIsCarregando(true)
    CirastServico.cadastrarTipoAtendimento(tipoCmd)
      .then(res => res.json())
      .then(data => {
        setTipoCmd(new TipoAtendimentoCirastCmd())
        exibirMensagemSucesso(`Tipo atendimento ${tipoCmd.nome} cadastrado com sucesso!`)
        fetchTipoAtendimento()
      })
      .finally(() => setIsCarregando(false))
  }

  function alterar() {

    if (!tipoEditar?.nome || !tipoEditar?.valor) {
      exibirMensagemErro('Preencha o nome e o valor.')
      return
    }

    setIsCarregando(true)
    CirastServico.alterarTipoAtendimento(tipoEditar)
      .then(res => res.json())
      .then(data => {
        close()
        exibirMensagemSucesso(`Tipo atendimento ${tipoEditar.nome} alterado com sucesso!`)
        setTipoEditar(new TipoAtendimentoCirast())
        fetchTipoAtendimento()
      })
      .finally(() => setIsCarregando(false))
  }

  function fetchTipoAtendimento() {
    setIsCarregando(true)
    CirastServico.getTipoAtendimento()
      .then(res => res.json())
      .then(dados => {
        setTipos(dados)
      })
      .finally(() => setIsCarregando(false))
  }

  function abrirModal(t: TipoAtendimentoCirast) {
    setTipoEditar(t)
    open()
  }

  useEffect(() => {
    fetchTipoAtendimento()
  }, []);

  return (
    <PaginaLogada titulo="Cadastro Atendimento Cirast" isCarregando={isCarregando}>
          <CardPadrao>
            <Grid>
              <Grid.Col span={COL_RESP_3}>
                <TextInput
                  label={"Nome"}
                   value={tipoCmd.nome}
                   onChange={(e) => setTipoCmd({...tipoCmd, nome: e.target.value})}
                />
              </Grid.Col>
              <Grid.Col span={COL_RESP_3}>
                <DinheiroInput
                  label={"Valor Por Consulta"}
                  value={tipoCmd.valor}
                   onChange={(e) => setTipoCmd({...tipoCmd, valor: Number(e)})}
                  />
              </Grid.Col>
              <Grid.Col span={COL_RESP_3} style={{alignSelf: "self-end"}}>
                <BotaoSalvar onClick={enviar} />
              </Grid.Col>
            </Grid>
          </CardPadrao>


      <CardPadrao mt={50}>
        <Table miw={700}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Ação</Table.Th>
              <Table.Th>Nome</Table.Th>
              <Table.Th>Valor Por Consulta</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {
              tipos?.map(t => {
                return(
                  <Table.Tr key={t.id}>
                    <Table.Td>
                      <Tooltip label={"Editar"}>
                        <ActionIcon ml={10} aria-label="Editar" color={COR.ALERTA}
                                    onClick={() => abrirModal(t)}>
                          <ICONE.ALTERAR />
                        </ActionIcon>
                      </Tooltip>
                    </Table.Td>
                    <Table.Td>{t.nome}</Table.Td>
                    <Table.Td>{formatarDinheiroItl(t.valor)}</Table.Td>
                  </Table.Tr>
                )
              })
            }
          </Table.Tbody>
        </Table>
      </CardPadrao>
      <Modal opened={modal} onClose={close} title="Alterar Tipo Atendimento Cirast">
        <Stack>

            <TextInput
              label={"Nome"}
              value={tipoEditar?.nome}
              onChange={(e) => setTipoEditar({...tipoEditar!!, nome: e.target.value})}
            />
            <DinheiroInput
              label={"Valor Por Consulta"}
              value={tipoEditar?.valor}
              onChange={(e) => setTipoEditar({...tipoEditar!!, valor: Number(e)})}
            />
            <BotaoSalvar onClick={alterar} />
        </Stack>
      </Modal>
    </PaginaLogada>
  )
}
